<form class="popupForm" style="min-height: 200px;" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      <span>Підтвердження видалення</span>
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="display: flex !important; min-height: 200px;">
      <div>
        <div>
          &nbsp;
        </div>

        <div class="flex-row-center flex-justify-space-between">
          <mat-radio-group matInput formControlName="duplicate_option" aria-labelledby="example-radio-group-label"
                           class="radio-group">
            <mat-radio-button class="radio-button" [value]="'option_1'">
              <div class="textCut">
                Видалити один запис
              </div>
            </mat-radio-button>
            <br>
            <mat-radio-button class="radio-button" [value]="'option_2'">
              <div class="textCut">
                Видалити всі записи цієї групи
              </div>
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <br><br>
      </div>
    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
        <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
          {{'cancel' | GetLabelPipe}}
        </button>
        <button type="submit" class="widerButton font16" mat-raised-button color="accent" (click)="handleSubmit()">
          {{'delete' | GetLabelPipe}}
        </button>
      </div>
    </div>
  </div>
</form>
